import Vue from 'vue';

Vue.filter('plural', <T>(base: string, values: T[]): string => {
    if (values.length === 1) {
        return base;
    }

    return `${base}s`;
});
